import React, { useState, useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { useTransition, animated } from 'react-spring';

import HeaderBox from '../header-box';
import './styles.css';

let timeout = null;

const Carousel = ({ header, copy, buttonsList }) => {
    const data = useStaticQuery(graphql`
        query TestimonialQuery {
            site {
                siteMetadata {
                    testimonials {
                        name
                        quote
                        image
                        href
                    }
                }
            }
        }
    `);

    const [state, setState] = useState({
        position: 0,
        timeout: null,
        transitions: {
            from: { opacity: 0, transform: 'translate3d(100%,0,0)' },
            enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
            leave: { opacity: 0, transform: 'translate3d(-50%,0,0)' },
        },
    });

    const carouselMove = adj => {
        let trans = {
            from: { opacity: 0, transform: 'translate3d(100%,0,0)' },
            enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
            leave: { opacity: 0, transform: 'translate3d(-50%,0,0)' },
        };
        if (adj < 0) {
            trans = {
                from: { opacity: 0, transform: 'translate3d(-100%,0,0)' },
                enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
                leave: { opacity: 0, transform: 'translate3d(50%,0,0)' },
            };
        }

        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            carouselMove(1);
        }, 2000);
        let position = state.position;
        if (position + adj >= data.site.siteMetadata.testimonials.length) {
            position = 0;
        } else if (position + adj < 0) {
            position = data.site.siteMetadata.testimonials.length - 1;
        } else {
            position += adj;
        }
        setState({
            position: position,
            transitions: trans,
        });
    };
    useEffect(() => {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            carouselMove(1);
        }, 10000);

        // cleanup
        return timeout ? clearTimeout(timeout) : null;
    });

    const pages = data.site.siteMetadata.testimonials.map(d => {
        return ({ style }) => {
            const innards = (
                <>
                    <div className="carousel-image">
                        <img alt="" loading="lazy" src={d.image} />
                    </div>
                    <div className="carousel-item-right">
                        <div className="carousel-quote-container">
                            <span className="carousel-quote">{d.quote}</span>
                        </div>
                        <div className="dispensary">{d.name}</div>
                    </div>
                </>
            );

            if (d.href) {
                return (
                    <animated.a
                        className="carousel-item"
                        href={d.href}
                        style={style}
                    >
                        {innards}
                    </animated.a>
                );
            }
            return (
                <animated.div className="carousel-item" style={style}>
                    {innards}
                </animated.div>
            );
        };
    });

    return (
        <div className="carousel">
            {header || copy ? (
                <HeaderBox copy={copy ? copy : null} header={header} />
            ) : null}
            <div className="carousel-container">
                <div
                    className="arrow-container"
                    onClick={() => carouselMove(-1)}
                >
                    <div className="back-arrow"></div>
                </div>
                <div className="carousel-item-container">
                    {useTransition(
                        state.position,
                        p => p,
                        state.transitions
                    ).map(({ item, props, key }) => {
                        let Page = pages[item];
                        return <Page key={key} style={props} />;
                    })}
                </div>
                <div
                    className="arrow-container"
                    onClick={() => carouselMove(1)}
                >
                    <div className="forward-arrow"></div>
                </div>
            </div>

            {buttonsList}
        </div>
    );
};

Carousel.propTypes = {
    buttonsList: PropTypes.arrayOf(PropTypes.element),
    copy: PropTypes.string,
    header: PropTypes.string,
};

export default Carousel;
